/* global $ */
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules'

function init () {
  $(document).ready(function () {
    // initialize swiper when document ready
    const postsSliders = $('.swiper-container.posts-slider')
    postsSliders.each(function() {
        const postsSlider = $(this)
        if(postsSlider.length > 0) {
            const swiper = new Swiper(postsSlider[0], {
                modules: [Navigation, Pagination, Autoplay, EffectFade],
                watchOverflow: true,
                autoHeight: false,
                centeredSlides: false,
                slidesPerView: 'auto',
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                loop: true,
                navigation: {
                    nextEl: postsSlider.parent().find('.swiper-button-next')[0],
                    prevEl: postsSlider.parent().find('.swiper-button-prev')[0]
                }
            })
            swiper.init()
        }
    });
  })
}

export default {
  init
}
